import { render, staticRenderFns } from "./CodeChangeProduct.vue?vue&type=template&id=8c805bc8&scoped=true"
import script from "./CodeChangeProduct.vue?vue&type=script&lang=js"
export * from "./CodeChangeProduct.vue?vue&type=script&lang=js"
import style0 from "./CodeChangeProduct.vue?vue&type=style&index=0&id=8c805bc8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c805bc8",
  null
  
)

export default component.exports